import React from "react";
import { Members } from "./../Home/Member/member";
import "./../Home/Member/members.css";

// GENERAL CHAIRS
import Prof_Wan_Young_Chung from "./../../Images/Prof_Wan_Young_Chung.jpg";
import Prof_Uma_Shanker_Tiwary from "./../../Images/Prof_Uma_Shanker_Tiwary.jpg";

// ADVISORY CHAIRS
import Prof_Ajay_Gupta from "./../../Images/Prof_Ajay_Gupta.jpg";
import Prof_Dae_Ki_Kang from "./../../Images/Prof_Dae_Ki_Kang.jpg";
import Prof_Jan_Treur from "./../../Images/Prof_Jan_Treur.jpg";
import Prof_Venkatasubr_Manian_Ganesan from "./../../Images/Prof_Venkatasubr_Manian_Ganesan.jpg";

// PROGRAM CHAIRS
import Prof_Dhananjay_Singh from "./../../Images/Prof_Dhananjay_Singh.jpg";
import Dr_Sang_Joong_Jung from "./../../Images/Dr_Sang_Joong_Jung.jpg";
import Dr_Jong_Hoon_Kim from "./../../Images/Dr_Jong_Hoon_Kim.png";

//TECHNICAL PROGRAM CHAIRS
import Dr_David_Bong_Jun_Choi from "./../../Images/Dr_David_Bong_Jun_Choi.png";
import Dr_Madhusudan_Singh from "./../../Images/Dr_Madhusudan_Singh.jpg";
// import Prof_Uma_Shanker_Tiwary from "./../../Images/Prof_Uma_Shanker_Tiwary.jpg";

// Workshop/Tutorial Chairs
import Dr_Naagmani_Molakatala from "./../../Images/Dr_Naagmani_Molakatala.jpg";
import Dr_Ajit_Kumar from "./../../Images/Dr_Ajit_Kumar.jpg";
import Dr_Rajiv_Singh from "./../../Images/Dr_Rajiv_Singh.jpg";
import Dr_Ikechi_Ukaegbu from "./../../Images/Dr_Ikechi_Ukaegbu.jpg";

// Publicity Chairs
import Dr_Zongyang_Gong from "./../../Images/Dr_Zongyang_Gong.jpg";
import Dr_Mohd_Helmy_Bin_Abd_Wahab from "./../../Images/Dr_Mohd_Helmy_Bin_Abd_Wahab.jpg";
import Sanjay_Singh from "./../../Images/Sanjay_Singh.jpg";

// Industrial/Entrepreneurial Chairs
import Dr_Mario_Jose_Divan from "./../../Images/Dr_Mario_Jose_Divan.jpg";
import Garima_Bajpai from  "./../../Images/Garima_Bajpai.jpg";

// Web Chairs
import Dr_Hanumant_Singh from "./../../Images/Dr_Hanumant_Singh.jpg";
// import Dr_Rajiv_Singh from "./../../Images/Dr_Rajiv_Singh.jpg";

export const Organizing = () => {
  //    GENERAL CHAIRS
  const Name1 = [
    "Professor Wan Young Chung",
    "Professor Uma Shanker Tiwary ",
  ];

  const Info1 = [
    "Department of Artificial Intelligence Pukyong National University, S Korea",
    "Dept. of Information Technology Indian Institute of Information Technology, Allahabad, India",
  ];

  const P_website1 = ["https://scholar.google.co.kr/citations?user=_GmF0tkAAAAJ&hl=ko", "https://it.iiita.ac.in/?pg=facultypage&uid=ust"];

  const Pic1 = [Prof_Wan_Young_Chung, Prof_Uma_Shanker_Tiwary];

  //   ADVISORY CHAIRS
  const Name2 = [
    "Prof. Ajay Gupta",
    "Prof. Dae-Ki Kang",
    "Prof. Jan Treur",
    "Prof. Venkatasubramanian Ganesan"
  ];

  const Info2 = [
    "Department of Computer Science Western Michigan University, Kalamazoo, USA",
    "Dept. of Computer Science Dongseo University, Busan, S. Korea",
    "Dept. of Artificial Intelligence, Vrije Universiteit Amsterdam, NL",
    "Department of Psychiatry, National Institute of Mental Health & Neurosciences, Bangalore, India"
  ];

  const P_website2 = ["https://cs.wmich.edu/~gupta/", "https://scholar.google.com/citations?user=U7OeExwAAAAJ", "https://orcid.org/0000-0003-2466-9158", "https://www.transpsychlab.org/venkatasubramanian.html"];

  const Pic2 = [Prof_Ajay_Gupta, Prof_Dae_Ki_Kang, Prof_Jan_Treur, Prof_Venkatasubr_Manian_Ganesan];

  //   PROGRAM CHAIRS
  const Name3 = [
    "Dhananjay Singh",
    "Dr. Sang-Joong Jung ",
    "Dr. Jong-Hoon Kim"

  ];

  const Info3 = [
    "School of Professional Studies, Saint Louis University, MO, USA",
    "Department of Computer Science, Dongseo University, Busan, S. Korea",
    "Department Computer Science, Kent State University, Kent, USA"
  ];

  const P_website3 = ["https://www.resenselab.org/members", "", "https://www.atr.cs.kent.edu/people/jong-hoon_kim/"];

  const Pic3 = [Prof_Dhananjay_Singh, Dr_Sang_Joong_Jung, Dr_Jong_Hoon_Kim];

  // TECHNICAL PROGRAM CHAIRS
  const Name4 = [
    "Dr. David (Bong Jun) Choi  ",
    "Dr. Madhusudan Singh ",
    "Professor Uma Shanker Tiwary ",
  ];

  const Info4 = [
    "Computer Science and Engineering Soongsil University, Seoul, Korea",
    "School of Engineering, Science and Management Oregon Institute of Technology, Klamath Falls, USA",
    "Center of Cognitive Computing IIIT-Allahabad, India",
  ];

  const P_website4 = ["", "https://scholar.google.com/citations?user=IW9lu0cAAAAJ", "https://it.iiita.ac.in/?pg=facultypage&uid=ust"];

  const Pic4 = [Dr_David_Bong_Jun_Choi, Dr_Madhusudan_Singh, Prof_Uma_Shanker_Tiwary];

  //   Workshop Chair
  const Name5 = [
    "Dr. Naagmani Molakatala",
    "Dr. Ajit Kumar",
    "Dr. Rajiv Singh",
    "Dr. Ikechi Ukaegbu"
  ];

  const Info5 = [
    "Computer and Information Sciences, University of Hyderabad, India",
    "Computer Science and Engineering, Soongsil University, Seoul, South Korea",
    "Department of Computer Science Banasthali Vidyapith, Rajasthan, India",
    "Dept. of Electrical and Computer Eng., Nazarbayev University, Kazakhstan"
  ];

  const P_website5 = ["", "", "", ""];

  const Pic5 = [Dr_Naagmani_Molakatala, Dr_Ajit_Kumar, Dr_Rajiv_Singh, Dr_Ikechi_Ukaegbu];

  // Publicity Chairs
  const Name6 = [
    "Dr. Zongyang Gong ",
    "Dr. Mohd Helmy Bin Abd Wahab",
    "Sanjay Singh "
  ];

  const Info6 = [
    "School of Professional Studies Saint Louis University, USA ",
    "Department of Computer Engineering, University Tun Hussein Onn Malaysia, Malaysia", 
    "Department of Civil Engineering, Motilal National Institute of Technology Allahabad, India"
  ];

  const P_website6 = ["", "", ""];

  const Pic6 = [Dr_Zongyang_Gong, Dr_Mohd_Helmy_Bin_Abd_Wahab, Sanjay_Singh];

  // Industrial/Entrepreneurial Chairs
  const Name7 = [
    "Dr. Mario Jose Divan",
    "Garima Bajpai",
  ];

  const Info7 = [
    "Architect & IoTG Services, Intel Corporation, USA",
    "Canada DevOps Community of Practice, Canada"
  ];

  const P_website7 = ["", ""];

  const Pic7 = [Dr_Mario_Jose_Divan, Garima_Bajpai];

  // Tutorial Chairs
  const Name8 = [
    "Dr. Hanumant Singh Shekhawat",
    "Dr. Rajiv Singh "
  ];

  const Info8 = [
    "IIT Guwahati ",
    "Department of Computer Science Banasthali Vidyapith, Rajasthan, India"
  ];

  const P_website8 = ["", ""];

  const Pic8 = [Dr_Hanumant_Singh, Dr_Rajiv_Singh];

  return (
    <section className="container">
      <Members
        heading="GENERAL CHAIRS"
        Name={Name1}
        Info={Info1}
        P_website={P_website1}
        Pic={Pic1}
      />
      <Members
        heading="ADVISORY CHAIRS"
        Name={Name2}
        Info={Info2}
        P_website={P_website2}
        Pic={Pic2}
      />
      <Members
        heading="PROGRAM CHAIRS"
        Name={Name3}
        Info={Info3}
        P_website={P_website3}
        Pic={Pic3}
      />
      <Members
        heading="TECHNICAL PROGRAM CHAIRS"
        Name={Name4}
        Info={Info4}
        P_website={P_website4}
        Pic={Pic4}
      />
      <Members
        heading="WORKSHOP CHAIRS"
        Name={Name5}
        Info={Info5}
        P_website={P_website5}
        Pic={Pic5}
      />
      <Members
        heading="PUBLICITY CHAIRS"
        Name={Name6}
        Info={Info6}
        P_website={P_website6}
        Pic={Pic6}
      />
      <Members
        heading="INDUSTRIAL/ENTREPRENEURIAL CHAIRS"
        Name={Name7}
        Info={Info7}
        P_website={P_website7}
        Pic={Pic7}
      />
      <Members
        heading="TUTORIAL CHAIRS"
        Name={Name8}
        Info={Info8}
        P_website={P_website8}
        Pic={Pic8}
      />
      <hr className="hr-style" />
    </section>
  );
};
